import { combineReducers } from 'redux';
import list from './list';
import paging from './paging';
import sorting from './sorting';
import filters from './filters';
import count from './count';
import detail from './detail';

export default combineReducers({
  list,
  paging,
  sorting,
  filters,
  count,
  detail,
});
